import { respondFrom } from 'common/styles/Responsive.styles'
import styled from 'styled-components'

export const StyledContainer = styled.div`
  width: 100%;
  height: 430px;
  margin-top: 26px;
}
`

export const StyledRowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`

export const StyledColContainer = styled.div<{ $disabled: boolean }>`
  width: 25%;
  min-height: 70px;
  max-height: 70px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  label {
    display: block;
  }

  ${respondFrom.smallDesktop`
    width: 33.33%;
  `}

  ${respondFrom.lessThanTablet`
    width: 50%;
  `}

  ${respondFrom.mobile`
    width: 100%;
  `}

  .cViiLY .MuiFormControl-root {
    width: 65%;
    margin-top: 10px;
    color: #495057;
  }

  label {
    margin-bottom: 5px;
    font-size: 14px;
    color: #495057;
  }

  .MuiInputLabel-animated {
    padding: 3px 10px 5px;
  }

  .MuiFormLabel-root.Mui-disabled {
    color: #ededed;
  }

  .MuiFormControlLabel-label.Mui-disabled {
    color: #ededed;
  }

  .MuiFormLabel-root {
    padding-top: 3px;
    font-size: 14px;
    color: ${({ $disabled }) => ($disabled ? '#ededed' : '#495057')};
  }

  .MuiFormHelperText-root.Mui-disabled {
    color: #ededed;
  }

  .MuiFormHelperText-root {
    padding-left: 10px;
  }

  .makeStyles-root-9 > * {
    margin: 0;
  }

  .makeStyles-formControl-19 {
    margin: 0;
  }

  .MuiInputBase-root.Mui-disabled {
    border: 1px solid #ededed;
  }

  .MuiInputBase-root {
    width: 230px;
    height: 40px;
    font-size: 14px;
    border: 1px solid #7ca5ca;
    border-radius: 4px;
    padding-right: 10px;

    ${respondFrom.lessThanTablet`
      width: 100%;
    `}

    &::before {
      border-bottom: 1px solid transparent;
    }

    &::after {
      border-bottom: 1px solid transparent;
    }

    .MuiInputBase-input {
      padding: 10px 10px 6px;
    }
    &:hover {
      &::before {
        border-bottom: 1px solid transparent;
      }
    }
  }

  .MuiInputLabel-outlined {
    transform: translate(4px, 10px) scale(1);
    background-color: #fff;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    ${respondFrom.lessThanTablet`
      max-width: 160px;
    `}
    ${respondFrom.mobile`
      max-width: 240px;
    `}
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(4px, -8px) scale(0.75);
    max-width: unset;
  }

  .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiFormHelperText-contained {
    margin-left: 0;
  }

  .MuiFormControl-root {
    margin: 0 0 0 0;

    ${respondFrom.lessThanTablet`
      min-width: 100%;
      > div {
        width: 100%;
      }
    `}
  }
`

export const StyledCol = styled.div`
  .MuiInputBase-root {
    border: ${({ validationError }) => (validationError ? '1px solid red' : '1px solid #7ca5ca')};
  }
`

export const StyledHeader = styled.div`
  margin-bottom: 16px;
  font-weight: 600;
  font-size: 16px;
  line-height: 28px;
  color: ${({ disabled }) => (disabled ? '#ededed' : '#495057')};
`

export const StyledContinueButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  p {
    color: #324245;
  }
  ${respondFrom.lessThanTablet`
  margin-top: 20px;
`}

  .calculate-rating {
    margin-left: auto;
    margin-right: 24px;
    display: flex;
    align-items: center;

    > span {
      margin-right: 10px;
      color: #495057;
      font-size: 14px;
    }

    .rating {
      color: #044f98;
      font-weight: 600;

      ::first-letter {
        text-transform: capitalize;
      }
    }
  }
`
